import React from "react";
import { Table } from "antd";

const ExcludedDatesTable = ({ excludedData }) => {
  if (!excludedData || excludedData.length === 0) {
    return null;
  }

  const columns = [
    {
      title: "Excluded Date",
      dataIndex: "date",
      key: "date",
      render: (val) => val || "-",
    },
    {
      title: "Average Length (cm)",
      dataIndex: "averageLength",
      key: "averageLength",
      render: (val) => val?.toFixed?.(1) ?? "-",
    },
    {
      title: "80-95 Percentile Length (cm)",
      dataIndex: "averagePercentile80_95",
      key: "averagePercentile80_95",
      render: (val) => val?.toFixed?.(1) ?? "-",
    },
  ];

  return (
    <>
      <h3 className="font-bold text-lg mb-2">Excluded Dates</h3>
      <Table
        className="w-full"
        columns={columns}
        dataSource={excludedData.map((item, idx) => ({ ...item, key: idx }))}
        pagination={false}
      />
    </>
  );
};

export default ExcludedDatesTable;
